import { ButtonType, ButtonWidget, Tooltip } from '@tableau/widgets';
import React from 'react';

import { FeatureFlags } from '~src/ts/FeatureFlags';

import { isSingleEmbeddedDatasource, isUsingBridge } from '../../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { hideLaunchEditOnMobile } from '../../app/utils/MobileHelper';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IDataSourceDetailInfo } from '../models/IDataSourceInfo';
import { IDatasourceActions } from '../ServerApi/types/IDatasourceActions';

export function createEditDataSourceButton(params: {
  readonly item: IContentInfo<'datasource'>;
  readonly actions: IDatasourceActions;
  readonly editDatasource: () => void;
}): JSX.Element {
 if (FeatureFlags.editPublishedDataSourceEnabled
  && !isSingleEmbeddedDatasource([ params.item ])
  && !hideLaunchEditOnMobile()
  && params.actions
  && params.actions.launchWebAuthoring
  && params.actions.editDatasource){
    const isBridge = isUsingBridge(params.item as IDataSourceDetailInfo);
    return (<>
      <ButtonWidget
        children={Messages.editDatasource()}
        buttonType={ButtonType.Outline}
        handleClick={params.editDatasource}
        testId={'action-edit-datasource'}
        disabled={isBridge}/>
        {isBridge && <Tooltip testId={'edit-datasource-tooltip'} getContent={() =>
          <span>{Messages.errorEditDatasourceDisabledForBridge()}</span>}/>}
      </>);
  }
}
